// extracted by mini-css-extract-plugin
module.exports = {"btn":"clear-search-button__btndfH","img":"clear-search-button__imgxVU"};